import { widgetSetupSelector } from "../widgetSetupSelector";
import { RootState } from "../../../../store";

export const widgetSetupWidgetNameSelector = (
  state: RootState,
): string | undefined => {
  return widgetSetupSelector(state)?.name;
};
